<template>
    <div class="time-zone">
        <el-select :value="zone" placeholder="请选择" @change="changeTimeZone" style="width: 106px;" size="mini">
            <el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>
            <el-option label="时区-UTC" value="UTC">时区-UTC</el-option>
        </el-select>
        <el-button-group class="ml6">
            <el-button :type="isToday?'primary':''" @click="quickSelect('today')" size="mini" class="quick-date-btn">今天</el-button>
            <el-button :type="isYesTd?'primary':''" @click="quickSelect('yesTd')" size="mini" class="quick-date-btn">昨天</el-button>
            <el-button :type="isLast3?'primary':''" @click="quickSelect('last3')" size="mini" class="quick-date-btn">近三天</el-button>
            <el-button :type="isLast7?'primary':''" @click="quickSelect('last7')" size="mini" class="quick-date-btn">近七天</el-button>
        </el-button-group>

        <el-date-picker
            size="mini"
            class="ml6"
            :value="rangeTime"
            type="daterange"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @input="changeRangeTime"
            :clearable="false"
            :editable="false"
            style="width: 220px;">
        </el-date-picker>
        <el-button type="primary" size="mini" class="ml10" @click="handleClick" :loading="addLoading" v-if="pageFuncNames.includes('add_ad')">+ 创建广告</el-button>
    </div>
</template>

<script>
    import dateShortcuts from './dateShortcuts.js';
    import dayjs from 'dayjs';
    import API from '@/api/marketManage/apple/index';
    import {mapGetters} from 'vuex';

    export default {
        name: "TimeZone",
        props:{
            zone:String,
            rangeTime:Array,
            pageFuncNames:Array,
            addLoading:Boolean,
        },
        data(){
            return {
                range:[],
                pickerOptions:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        dateShortcuts.today,
                        dateShortcuts.yesterday,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                        dateShortcuts.last30,
                        dateShortcuts.thisWeek,
                        dateShortcuts.thisMonth,
                        dateShortcuts.thisQuarter,
                    ],
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    },
                },
            }
        },
        computed:{
            ...mapGetters(['apple_common_config']),
            isToday(){
                if(this.rangeTime.length<=0) return false;
                let today = dayjs();
                return today.isSame(dayjs(this.rangeTime[0]),'day')&&today.isSame(dayjs(this.rangeTime[1]),'day');
            },
            isYesTd(){
                let yesTd = dayjs().subtract(1, 'day');
                return yesTd.isSame(dayjs(this.rangeTime[0]),'day')&&yesTd.isSame(dayjs(this.rangeTime[1]),'day');
            },
            isLast3(){
                let today = dayjs();
                return today.subtract(2, 'day').isSame(dayjs(this.rangeTime[0]),'day')&&today.isSame(dayjs(this.rangeTime[1]),'day');
            },
            isLast7(){
                let today = dayjs();
                return today.subtract(6, 'day').isSame(dayjs(this.rangeTime[0]),'day')&&today.isSame(dayjs(this.rangeTime[1]),'day');
            },
        },
        methods:{
            handleClick(){
                this.$emit('click-add');
            },
            quickSelect(val){
                let today = dayjs().format('YYYY-MM-DD');
                let range = [];
                if(val=='today') {
                    range = [today,today];
                }else if(val=='yesTd'){
                    let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                    range = [yesTd,yesTd];
                }else if(val=='last3'){
                    let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                    range = [last3,today];
                }else if(val=='last7'){
                    let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                    range = [last7,today];
                }
                let typeMap = {
                    today:0,
                    yesTd:1,
                    last3:3,
                    last7:7,
                };
                API.editCommonConfig({
                    dynamic_day_type:typeMap[val],
                    search_filter_toggle:this.apple_common_config.search_filter_toggle,
                });
                this.$store.commit('apple/SET_COMMON_CONFIG',{
                    dynamic_day_type:typeMap[val],
                    search_filter_toggle:this.apple_common_config.search_filter_toggle,
                });

                this.changeRangeTime(range);
            },
            changeTimeZone(val){
                this.$emit('change',val,this.rangeTime);
                console.log('changeTimeZone',val);
                this.$store.commit('apple/SET_TIME_ZONE',val);
            },
            changeRangeTime(range){
                console.log('change time',range);

                let range0 = range[0]||'';
                let range1 = range[1]||'';
                let today = dayjs().format('YYYY-MM-DD');
                let yesTd = dayjs().subtract(1,'day').format('YYYY-MM-DD');
                let last3 = dayjs().subtract(2,'day').format('YYYY-MM-DD');
                let last7 = dayjs().subtract(6,'day').format('YYYY-MM-DD');
                let dynamicDayType = '';
                if(dayjs(range0).format('YYYY-MM-DD')==today&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '0';
                }else if(dayjs(range0).format('YYYY-MM-DD')==yesTd&&dayjs(range1).format('YYYY-MM-DD')==yesTd){
                    dynamicDayType = '1';
                }else if(dayjs(range0).format('YYYY-MM-DD')==last3&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '3';
                }else if(dayjs(range0).format('YYYY-MM-DD')==last7&&dayjs(range1).format('YYYY-MM-DD')==today){
                    dynamicDayType = '7';
                }
                if(dynamicDayType){
                    API.editCommonConfig({
                        dynamic_day_type:dynamicDayType,
                        search_filter_toggle:this.apple_common_config.search_filter_toggle,
                    });
                }
                this.$emit('change',this.zone,range);
            },

        }
    }
</script>

<style lang="scss" scoped>
    .quick-date-btn{
        padding: 7px 10px;
        top:-1px;
    }
</style>
